import { service } from '@maia/cart';
import { Button, PageHeader, TextArea, Typography } from '@maia/ui';
import { useForm } from '@tanstack/react-form';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '../../../../../../../src/main';
import * as v from 'valibot';

export const Route = createFileRoute(
  '/_authenticated/add-insurance/$customer/_layout-cart/cart/$cart/_layout-cart/special',
)({
  component: RouteComponent,
  loaderDeps: ({ search: { products } }) => ({ products }),
  beforeLoad: async ({ params: { cart } }) => {
    await queryClient.invalidateQueries({
      queryKey: ['cart', cart],
    });
  },
  validateSearch: v.object({
    products: v.string(),
  }),
});

function RouteComponent() {
  const { cart: cartGuid, customer: customerGuid } = Route.useParams();
  const navigate = Route.useNavigate();

  const form = useForm({
    defaultValues: {
      description: '',
    },
    onSubmit: ({ value }) => {
      mutate({
        type: 'special',
        description: value.description,
      });
    },
  });

  const { mutate } = useMutation({
    mutationFn: (
      params: Pick<
        Parameters<typeof service.submitCart>[number],
        'type' | 'description'
      >,
    ) =>
      service.submitCart({
        cartGuid: cartGuid,
        customerGuid: customerGuid,
        ...params,
      }),
    onSuccess: () => {
      return navigate({
        to: '/add-insurance/$customer/special-send',
        params: {
          customer: customerGuid,
        },
      });
    },
  });

  return (
    <div className="layout-sidebar">
      <PageHeader
        backLink={{ href: '/', text: 'Terug' }}
        title="Aanvullende informatie"
        className="area-page-header"
      />
      <div className="area-page-content content-grid">
        <form
          className="col-span-8 flex flex-col"
          onSubmit={(event) => {
            event.preventDefault();
            event.stopPropagation();
            form.handleSubmit();
          }}
        >
          <form.Field name="description">
            {(field) => (
              <label>
                <Typography
                  variant="body-s"
                  weight="medium"
                  className="text-grayscale500 mb-12 inline-block"
                >
                  Zijn er nog bijzonderheden waar rekening gehouden moet worden?
                </Typography>
                <TextArea
                  onChange={(e) => field.handleChange(e.target.value)}
                  onBlur={field.handleBlur}
                  value={field.state.value}
                />
              </label>
            )}
          </form.Field>
          <Button type="submit" intent="cta" className="mt-24 self-end">
            Versturen
          </Button>
        </form>
      </div>
    </div>
  );
}
